import { render } from "./widgets.vue?vue&type=template&id=2df1b765"
import script from "./widgets.vue?vue&type=script&lang=js"
export * from "./widgets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__